import { isExternalLink, isPartnerLink, stripTags } from "@dl/declarations";

interface MarkdownFormatterProps {
  className?: string;
  text: string;
}

export const MarkdownFormatter: React.FC<MarkdownFormatterProps> = ({ text, ...restOfProps }) => {
  return (
    stripTags(text)
      // replace markdown links
      .replace(/\[([^[]+)\](\(([^)]*))\)/gim, (_matched, p1, _p2, p3) => {
        if (isExternalLink(p3)) {
          return `<a href="${p3}" target="_blank" rel="${isPartnerLink(p3) ? '' : 'nofollow'}">${p1}</a>`
        }

        return `<a href="${p3}">${p1}</a>`
      })
      // markdown bold
      .replace(/\*\*(.+?)\*\*(?!\*)/g, '<b>$1</b>')
      // mardkdown italic
      .replace(/\*([^*><]+)\*/g, '<i>$1</i>')
      // render paragraphs
      .split(/\n\s*\n/)
      .map((content, i) => {
        return <p key={i} dangerouslySetInnerHTML={{ __html: content.trim() }} {...restOfProps}></p>
      })
  )
}

interface MarkdownTutorialProps {
  showTitle?: boolean;
}

export const MarkdownTutorial: React.FC<MarkdownTutorialProps> = ({ showTitle = true }) => {
  return (
    <div>
      {showTitle && <p className="title">You can use markdown to add the following elements:</p>}
      <ul>
        <li>
          <span style={{ fontWeight: 'bold' }}>[DL News](https://www.dlnews.com)</span> adds a link to{' '}
          <span style={{ fontWeight: 'bold' }}>https://www.dlnews.com</span> with the text{' '}
          <span style={{ fontWeight: 'bold' }}>DL News</span>
        </li>
        <li>**bold text**,  *italic text*</li>
      </ul>
    </div>
  )
}
